import { getItem } from '../../utility/localStorageControl';

export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const EMAIL_ENDPOINT = process.env.REACT_APP_EMAIL_API_ENDPOINT;
export const SOCIAL_ENDPOINT = process.env.REACT_APP_SOCIAL_API_ENDPOINT;
export const OMNICANAL_ENDPOINT = process.env.REACT_APP_OMNICANAL_API_ENDPOINT;
export const REPORTS_ENDPOINT = process.env.REACT_APP_REPORTS_API_ENDPOINT;
export const GRAPHQL_ENDPOINT = process.env.REACT_APP_GRAPHQL_API_ENDPOINT;
export const GRAPHQL_KEY = process.env.REACT_APP_GRAPHQL_API_KEY;
export const FULLFILLMENT_ENDPOINT = process.env.REACT_APP_FULLFILLMENT_API_ENDPOINT;
// Gateway único de los micros nuevos; de aquí derivan users_new y tickets.
export const APIGW = process.env.REACT_APP_APIGW;
export const MS_USERS_ENDPOINT = `${APIGW}users_new/`;
export const MS_TICKETS_ENDPOINT = `${APIGW}tickets/`;

export const authHeader = () => ({
  Authorization: `Bearer ${getItem('access_token')}`,
});
